module.exports = __webpack_public_path__ + "static/media/embedded.c2336d21.svg";